/** Currencies allowed on organization create/edit (pricing & checkout). */
export const ORGANIZATION_FORM_CURRENCIES = [
  { code: 'NGN', label: 'Nigerian Naira (NGN)' },
  { code: 'USD', label: 'US Dollar (USD)' },
  { code: 'GBP', label: 'British Pound (GBP)' },
  { code: 'EUR', label: 'Euro (EUR)' },
]

/** Currencies offered when configuring platform payment gateways (checkout availability). */
export const PAYMENT_GATEWAY_CURRENCIES = [
  ...ORGANIZATION_FORM_CURRENCIES,
  { code: 'CAD', label: 'Canadian Dollar (CAD)' },
  { code: 'GHS', label: 'Ghanaian Cedi (GHS)' },
  { code: 'KES', label: 'Kenyan Shilling (KES)' },
  { code: 'ZAR', label: 'South African Rand (ZAR)' },
]

/** @type {{ code: string; label: string }[]} */
export const CURRENCIES = [
  ...PAYMENT_GATEWAY_CURRENCIES,
]

export function getCurrencyLabel(code) {
  return CURRENCIES.find((c) => c.code === code)?.label ?? code
}
